import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _DiscoveryService_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";

/**
 * The discovery service acts as a 'public API' for our discovery
 * routes. Themes/plugins can use this service as a stable way
 * to learn information about the current route.
 */
let DiscoveryService = disableImplicitInjections(_class = (_class2 = (_DiscoveryService_brand = /*#__PURE__*/new WeakSet(), class DiscoveryService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _DiscoveryService_brand);
    _initializerDefineProperty(this, "router", _descriptor, this);
  }
  get onDiscoveryRoute() {
    const {
      currentRouteName
    } = this.router;
    return currentRouteName?.startsWith("discovery.") || currentRouteName?.startsWith("tags.show") || currentRouteName === "tag.show";
  }
  get category() {
    if (this.onDiscoveryRoute) {
      return _classPrivateGetter(_DiscoveryService_brand, this, _get_routeAttrs)?.category;
    }
  }
  get tag() {
    if (this.onDiscoveryRoute) {
      return _classPrivateGetter(_DiscoveryService_brand, this, _get_routeAttrs)?.tag;
    }
  }
  get currentTopicList() {
    if (this.onDiscoveryRoute) {
      return _classPrivateGetter(_DiscoveryService_brand, this, _get_routeAttrs)?.list;
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;
function _get_routeAttrs(_this) {
  return _this.router.currentRoute.attributes;
}
export { DiscoveryService as default };